import { render, staticRenderFns } from "./change_pwd_dialog.vue?vue&type=template&id=ba39ec5e"
import script from "./change_pwd_dialog.vue?vue&type=script&lang=js"
export * from "./change_pwd_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports